import { descriptionStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsDescription";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

descriptionStyles.wrapper = {
    css: css`
        body {
            font-size: 14px;
            color: ${getColor("text.accent")};
        }
        > div {
            font-size: 14px;
            color: ${getColor("text.accent")};
            p {
                margin-bottom: 6px;
                color: ${getColor("text.accent")};
                font-size: 14px !important;
            }
        }
    `,
};
